import useClevertapForItinerary from '@/src/hooks/analytics/clevertap/itinerary'
import { useGetSaveTravelerData } from '@/src/hooks/itinerary/useLoadUserData'
import { PassengerType, SavedTraveler } from '@/src/types/itinerary'
import { Box, Popper, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

export interface SavedTravelerListProps {
    travelerType: PassengerType
    openSavedTravelerList: boolean
    firstNameRef: React.RefObject<HTMLDivElement>
    onSavedTravelerSelect: (idx: number, traveler: SavedTraveler) => void
    idx: number
}

const SavedTravelerList = ({
    travelerType,
    openSavedTravelerList,
    firstNameRef,
    onSavedTravelerSelect,
    idx
}: SavedTravelerListProps) => {
    const { userData } = useGetSaveTravelerData()
    const { triggerItineraryEvent } = useClevertapForItinerary()
    const t = useTranslations('common')
    const samePaxTypeTravelers = userData?.travellers?.filter(
        traveler => traveler.personalDetails.paxType === travelerType
    )

    useEffect(() => {
        if (samePaxTypeTravelers?.length) {
            triggerItineraryEvent('Air_UI_Action', {
                action_name: 'show_old_traveller',
                action_type: 'BUTTON',
                pax_type: travelerType
            })
        }
    }, [samePaxTypeTravelers, triggerItineraryEvent, travelerType])

    if (!samePaxTypeTravelers) return null

    if (samePaxTypeTravelers?.length === 0) return null

    // Prevent input blur when clicking on the list
    const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault()
    }

    return (
        <Popper open={openSavedTravelerList} anchorEl={firstNameRef.current} placement="bottom-start">
            <Box
                onMouseDown={handleMouseDown}
                sx={{
                    borderRadius: 1,
                    width: 260,
                    boxShadow: '5px 5px 10px 5px rgba(0, 0, 0, 0.1)',
                    bgcolor: 'white',
                    p: 2
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxHeight: 250, overflow: 'auto' }}>
                    <Typography variant="caption" fontWeight={500} color="textDisabled">
                        {t('savedTravelers')}
                    </Typography>
                    {samePaxTypeTravelers.map(traveler => (
                        <Box
                            key={traveler.id}
                            sx={{ cursor: 'pointer' }}
                            onClick={e => {
                                e.preventDefault()
                                e.stopPropagation()
                                onSavedTravelerSelect(idx, traveler)
                                triggerItineraryEvent('Air_UI_Action', {
                                    action_name: 'select_from_traveller_list',
                                    action_type: 'BUTTON'
                                })
                            }}
                        >
                            <Typography variant="body2" fontWeight={500}>
                                {traveler.personalDetails.firstName} {traveler.personalDetails.lastName}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Popper>
    )
}

export default SavedTravelerList
